export default __webpack_public_path__ + "static/media/newRequests.859a98e9.svg";